import ReactGA from "react-ga4";
import { createTransform } from "redux-persist";

import { addCardsFromRecs } from "./cards";

const ADD_CARD = "clipboard/ADD_CARD";
const CLEAR_CLIPBOARD = "clipboard/CLEAR_CLIPBOARD";
const CLOSE_MOBILE_IMAGE = "clipboard/CLOSE_MOBILE_IMAGE";
const POP_REC = "clipboard/POP_REC";
const PROMOTE_TO_COMMANDER = "clipboard/PROMOTE_TO_COMMANDER";
const RECS = "clipboard/RECS";
const RECS_ERROR = "clipboard/RECS_ERROR";
const RECS_SUCCESS = "clipboard/RECS_SUCCESS";
const REMOVE_CARD = "clipboard/REMOVE_CARD";
const SET_VIEWER_IMAGE = "clipboard/SET_VIEWER_IMAGE";
const TOGGLE = "clipboard/TOGGLE";
const OPEN_MOBILE_IMAGE = "clipboard/OPEN_MOBILE_IMAGE";
const UNDO = "clipboard/UNDO";

const initialState = {
  cards: {},
  commander: null,
  error: "",
  isLoadingRecs: false,
  isOpen: false,
  mobileImageIsOpen: false,
  prevStates: [],
  recs: [],
  viewerImage: null,
};

export const ClipboardTransform = createTransform(
  (inboundState, key) => ({ ...initialState, cards: inboundState.cards, commander: inboundState.commander }),
  (outboundState, key) => outboundState,
  { whitelist: ["clipboard"] }
);

const appendPrevState = ({ cards, commander, prevStates }) => [...prevStates, { cards, commander }].slice(-10);

const clipboard = (state = initialState, action) => {
  switch (action.type) {
    case ADD_CARD: {
      if (action.url === state.commander) {
        return state;
      }
      return { ...state, cards: { ...state.cards, [action.url]: null }, error: "", prevStates: appendPrevState(state) };
    }
    case CLEAR_CLIPBOARD:
      return { ...initialState, isOpen: state.isOpen, prevStates: appendPrevState(state) };
    case CLOSE_MOBILE_IMAGE:
      return {
        ...state,
        mobileImageIsOpen: false,
      };
    case "LOCATION_CHANGE":
      return {
        ...state,
        error: "",
        isOpen: false,
        mobileImageIsOpen: false,
      };
    case OPEN_MOBILE_IMAGE:
      return {
        ...state,
        mobileImageIsOpen: true,
      };
    case POP_REC: {
      return {
        ...state,
        error: "",
        recs: [...state.recs.slice(0, action.recsIndex), ...state.recs.slice(action.recsIndex + 1)],
      };
    }
    case PROMOTE_TO_COMMANDER: {
      const { [action.url]: _, ...rest } = state.cards;
      const cards = Object.fromEntries(
        [...Object.keys(rest), state.commander].filter((x) => x).map((name) => [name, null])
      );
      return { ...state, cards, commander: action.url, error: "", prevStates: appendPrevState(state) };
    }
    case RECS:
      return {
        ...state,
        error: "",
        isLoadingRecs: true,
        recs: [],
      };
    case RECS_ERROR:
      return {
        ...state,
        error: action.error,
        isLoadingRecs: false,
      };
    case RECS_SUCCESS:
      return {
        ...state,
        isLoadingRecs: false,
        recs: action.recs,
      };
    case REMOVE_CARD: {
      const { [action.url]: _, ...cards } = state.cards;
      const commander = state.commander === action.url ? null : state.commander;
      return { ...state, cards, commander, error: "", prevStates: appendPrevState(state) };
    }
    case SET_VIEWER_IMAGE:
      return {
        ...state,
        viewerImage: action.image_uri,
      };
    case TOGGLE:
      return {
        ...state,
        isOpen: !state.isOpen,
        mobileImageIsOpen: false,
      };
    case UNDO: {
      const { prevStates } = state;
      const { cards, commander } = prevStates[prevStates.length - 1];
      return {
        ...state,
        cards,
        commander,
        error: "",
        prevStates: prevStates.slice(0, prevStates.length - 1),
      };
    }
    default:
      return state;
  }
};

export const addCard =
  ({ card, recsIndex }) =>
  (dispatch) => {
    if (recsIndex) {
      dispatch({ recsIndex, type: POP_REC });
    }
    if (card.is_partner) {
      card.cards.map((card) => dispatch({ type: ADD_CARD, url: card.url }));
    } else {
      dispatch({ type: ADD_CARD, url: card.sanitized_wo || card.url });
    }
    dispatch(setViewerImage(card.image_uris[0]));
  };

export const buyAtCardKingdom = () => (dispatch) => {
  const decklistParams = dispatch(getDecklistParams("\n"));
  const cardkingdomBaseUrl = "https://www.cardkingdom.com/builder";
  const edhrecPartnerParams =
    "partner=edhrec&utm_source=edhrec&utm_medium=clipboard&utm_campaign=edhrec&partner_args=clipboard";
  const url = cardkingdomBaseUrl + "?" + edhrecPartnerParams + "&" + decklistParams;
  ReactGA.event({ action: "Clipboard", category: "Outbound", label: url });
  window.open(url, "_blank");
};

export const buyAtTCGPlayer = () => (dispatch) => {
  const decklistParams = dispatch(getDecklistParams("||"));
  const tcgplayerBaseUrl = "https://store.tcgplayer.com/massentry";
  const edhrecPartnerParams =
    "partner=EDHREC&utm_campaign=affiliate&utm_medium=clipboard&utm_source=EDHREC&partner_args=clipboard";
  const url = tcgplayerBaseUrl + "?" + edhrecPartnerParams + "&" + decklistParams;
  ReactGA.event({ action: "Clipboard", category: "Outbound", label: url });
  window.open(url, "_blank");
};

export const clipboardIncludes = (url) => (dispatch, getState) => {
  const { cards, commander } = getState().clipboard;
  return url in cards || commander === url;
};

export const clearClipboard = () => ({ type: CLEAR_CLIPBOARD });

export const closeMobileImage = () => ({ type: CLOSE_MOBILE_IMAGE });

export const copyClipboard = () => (dispatch) => {
  const myText = Object.values(dispatch(getAllCards()))
    .map((card) => card.name)
    .sort()
    .join("\n");
  navigator.clipboard.writeText(myText);
};

export const exportToArchidekt = () => (dispatch) => {
  const decklistParams = dispatch(getDecklistParams("\n"));
  const baseUrl = "https://archidekt.com/cardImport";
  window.open(baseUrl + "?" + decklistParams, "_blank");
};

export const exportToMoxfield = () => (dispatch) => {
  const decklistParams = dispatch(getDecklistParams("\n"));
  const baseUrl = "https://www.moxfield.com/import";
  window.open(baseUrl + "?" + decklistParams, "_blank");
};

export const fetchRecs = () => async (dispatch, getState) => {
  dispatch({ type: RECS });
  const { cards, commander } = getState().clipboard;

  try {
    if (!commander) {
      throw new Error("Select a commander");
    }

    const res = await fetch("/api/recs", {
      body: JSON.stringify({
        cards: Object.keys(cards),
        commanders: [commander],
        full_card_data: true,
      }),
      headers: { "Content-Type": "application/json" },
      method: "POST",
    });
    const json = await res.json();
    if (json.error) throw new Error(json.error);
    await dispatch(addCardsFromRecs(json));
    return dispatch({ recs: json.inRecs, type: RECS_SUCCESS });
  } catch (error) {
    return dispatch({ error: error.message, type: RECS_ERROR });
  }
};

export const getAllCards = () => (dispatch, getState) => {
  const cards = getState().cards.cards;
  const clipboard = getState().clipboard;
  const allCards = Object.fromEntries(Object.keys(clipboard.cards).map((url) => [url, cards[url]]));
  if (clipboard.commander) allCards[clipboard.commander] = cards[clipboard.commander];
  return allCards;
};

export const getOrganizedCards = () => (dispatch, getState) => {
  const cards = getState().cards.cards;
  const clipboardCards = getState().clipboard.cards;
  const lists = {
    Artifact: { cards: [], i: 3, plural: "Artifacts" },
    Battle: { cards: [], i: 5, plural: "Battles" },
    Creature: { cards: [], i: 0, plural: "Creatures" },
    Enchantment: { cards: [], i: 4, plural: "Enchantments" },
    Instant: { cards: [], i: 1, plural: "Instants" },
    Land: { cards: [], i: 7, plural: "Lands" },
    Planeswalker: { cards: [], i: 6, plural: "Planeswalkers" },
    Sorcery: { cards: [], i: 2, plural: "Sorceries" },
  };
  Object.keys(clipboardCards)
    .map((name) => cards[name])
    .filter((x) => x)
    .map((card) => lists[card.primary_type]?.cards.push(card));
  return lists;
};

export const getPrices = () => (dispatch, getState) => {
  const allCards = dispatch(getAllCards());
  const cardkingdom = Object.values(allCards).reduce((acc, card) => {
    if (card?.prices?.cardkingdom?.price) {
      acc += card.prices.cardkingdom.price;
    }
    return acc;
  }, 0);
  const tcgplayer = Object.values(allCards).reduce((acc, card) => {
    if (card?.prices?.tcgplayer?.price) {
      acc += card.prices.tcgplayer.price;
    }
    return acc;
  }, 0);
  return { cardkingdom, tcgplayer };
};

const getDecklistParams = (delimiter) => (dispatch) => {
  const cards = dispatch(getAllCards());
  const decklistString = Object.values(cards)
    .map((card) => {
      if (!card.name.includes(" // ") || card.layout === "split") return card.name;
      return card.name.substring(0, card.name.indexOf(" // ")); // Remove transformed title text if it exists
    })
    .map((card) => "1 " + card)
    .join(delimiter);
  return "c=" + encodeURIComponent(decklistString);
};

export const handleClick = (cards) => (dispatch) => {
  if (cards.every((card) => dispatch(clipboardIncludes(card.sanitized_wo || card.url)))) {
    cards.map((card) => dispatch(removeCard(card.sanitized_wo || card.url)));
  } else {
    cards.map((card) => dispatch(addCard({ card })));
  }
};

export const openmobileImage = () => ({ type: OPEN_MOBILE_IMAGE });

export const promoteToCommander = (card) => (dispatch) => {
  dispatch(setViewerImage(card.image_uris[0]));
  return dispatch({ type: PROMOTE_TO_COMMANDER, url: card.url });
};

export const removeCard = (url) => ({ type: REMOVE_CARD, url });

export const setViewerImage = (image_uri) => ({ image_uri, type: SET_VIEWER_IMAGE });

export const toggleClipboard = () => ({ type: TOGGLE });

export const undo = () => ({ type: UNDO });

export default clipboard;
